<mui-form-field [label]="label">
  <input
    muiInput
    type="text"
    class="mui-autocomplete__input"
    data-qa="mui-autocomplete-input"
    [class.has--error]="!valid"
    [name]="name"
    [ngbTypeahead]="search"
    [(ngModel)]="value"
    (ngModelChange)="onChange()"
    (focus)="handleOnFocus($event)"
    (blur)="handleOnBlur()" />
  <div class="mui-input__trailing mui-input__trailing-icon">
    <i *ngIf="handleDisplayLoading()" [spinning]="true" mui-icon font="fa" name="spinner-third"></i>
    <i *ngIf="!valid" mui-icon name="exclamation-triangle" font="fa" class="mui-input__trailing__error-indicator fa-fw"></i>
  </div>
  <div class="mui-input__error" *ngIf="!valid">
    <ng-content></ng-content>
  </div>
</mui-form-field>
